import { useEffect, useState } from 'react';
import { useAffixManagerStore } from './AffixManagerContext.tsx';
import { computeOffsetByOrder } from './AffixManagerStore.ts';

/**
 * Hook che ritorna l'offset cumulativo degli affix globali registrati.
 *
 * Utile per elementi CSS `position: sticky` o componenti `Anchor`
 * che necessitano di un valore numerico per `top` o `offsetTop`.
 *
 * @param orderThreshold - se fornito, ritorna la somma delle altezze
 *   di tutti gli affix con `order` strettamente minore di questo valore.
 *   Se omesso, ritorna l'altezza totale di tutti gli affix registrati.
 * @returns offset in pixel. Ritorna 0 se nessun `AffixManagerProvider` è nel tree.
 */
export function useAffixOffset(orderThreshold?: number): number {
  const store = useAffixManagerStore();
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (!store) return;
    const subscription = store.snapshot$.subscribe(snapshot => {
      const newOffset =
        orderThreshold !== undefined
          ? computeOffsetByOrder(snapshot.sorted, orderThreshold)
          : snapshot.totalHeight;
      setOffset(newOffset);
    });
    return () => subscription.unsubscribe();
  }, [store, orderThreshold]);

  return offset;
}
